<div
  *ngIf="isWithinTimeframe"
  class="alert-banner"
  [class]="alertClass"
  [ngClass]="isAlertClosed ? 'close' : ''"
  role="alert"
>
  <div class="alert-banner__inner">
    <div class="header">
      <div class="header--content">
        <div class="header--content__wrapper">
          <hdi-icon
            class="header--content__wrapper__left-icon"
            [iconName]="headerIcon"
            [iconPrefix]="'far'"
            [size]="iconSize"
            [color]="iconColor"
          ></hdi-icon>
          <h5 *ngIf="isExpandable">{{ title | slice: 0 : 120 }}</h5>
          <button
            class="collapse-button"
            *ngIf="isExpandable"
            (click)="isExpandable ? toggleDropdown() : null"
            (keydown)="handleKeyDown($event)"
            [ngClass]="isDropdownOpen ? 'flip' : ''"
          >
            <hdi-icon
              [iconName]="'chevron-down'"
              [size]="iconSize"
              [color]="iconColor"
            ></hdi-icon>
          </button>
          <a
            *ngIf="!isExpandable"
            class="header--content__link"
            [href]="href"
            (click)="handleLinkClick($event, href)"
          >
            <h5>{{ title | slice: 0 : 120 }}</h5>
            <hdi-icon
              [iconName]="actionIcon"
              [iconPrefix]="'far'"
              [size]="iconSize"
              [color]="iconColor"
            ></hdi-icon>
          </a>
        </div>
        <button
          class="close-button"
          (click)="closeAlert()"
          (keydown)="handleKeyDown($event)"
        >
          <hdi-icon
            [iconName]="'close'"
            [iconPrefix]="'far'"
            [size]="iconSize"
            [isHover]="true"
            [color]="iconColor"
          ></hdi-icon>
        </button>
      </div>
    </div>

    <div class="dropdown" [ngClass]="isDropdownOpen ? 'show' : ''">
      <div class="dropdown__inner">
        <div class="dropdown--content">
          <div [innerHTML]="dropdownText"></div>
          <ng-container *ngIf="link">
            <hdi-link
              [label]="link.label | capitalize"
              [href]="link.href!"
              [hrefType]="
                link.hrefType ? link.hrefType : HrefType.ANGULAR_ROUTE
              "
              [title]="link.title ?? ''"
            ></hdi-link>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template>
  <div class="alert-banner alert-banner--loader">
    <ngx-skeleton-loader
      [theme]="{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        'margin-bottom': '0',
        'background-color': '#dfe1e6',
      }"
    ></ngx-skeleton-loader>
  </div>
</ng-template>
